import { PagenatedResponse, SearchPagenateQuery } from '@models/common';
import { AdminCreditPointLog } from '@models/credit-points';
import { create } from 'zustand';

const PAGE_SIZE = 20;

interface CreditPointLogsContainer {
  contents: AdminCreditPointLog[];
  page: number;
  size: number;
  total: number;
  hasNext: boolean;
}

interface CreditPointLogsStoreProps {
  searchResultContainer: CreditPointLogsContainer;
  searchQuery: SearchPagenateQuery;
  searchKeyword?: string;
  setStartDate: (date: string | null) => void;
  setEndDate: (date: string | null) => void;
  setSearchKeyword: (keyword: string) => void;
  updateSearchQuery: (query: { [key: string]: any }) => void;
  resetSearchQuery: () => void;
  setCreditPointLogsContainer: (result: PagenatedResponse<AdminCreditPointLog>) => void;
}

export const useCreditPointLogsStore = create<CreditPointLogsStoreProps>((set) => ({
  searchResultContainer: {
    contents: [] as AdminCreditPointLog[],
    total: 0,
    page: 0,
    size: 0,
    hasNext: false,
  },
  searchQuery: {
    page: 0,
    size: PAGE_SIZE,
  },
  setStartDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, startDate: date } };
    });
  },
  setEndDate: (date: string | null) => {
    set((state) => {
      return { ...state, searchQuery: { ...state.searchQuery, endDate: date } };
    });
  },
  searchKeyword: undefined,
  setCreditPointLogsContainer: (result) => {
    set((state) => {
      const contents = new Array(result.total || PAGE_SIZE);
      contents.splice(result.page * result.size, result.size, ...(result?.contents || []));
      const newValue = { ...state.searchResultContainer, ...result, contents: contents };
      return { ...state, searchResultContainer: newValue };
    });
  },
  setSearchKeyword: (keyword: string) => {
    set((state) => {
      return {
        ...state,
        searchKeyword: keyword,
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  updateSearchQuery: (query: { [key: string]: any }) => {
    set((state) => {
      return {
        ...state,
        searchQuery: { ...state.searchQuery, ...query },
        searchResultContainer: { ...state.searchResultContainer, size: 0 },
      };
    });
  },
  resetSearchQuery: () => {
    set({
      searchQuery: {
        page: 0,
        size: PAGE_SIZE,
        type: 'all',
        startDate: undefined,
        endDate: undefined,
      },
    });
  },
}));
